import { render, staticRenderFns } from "./Modal.html?vue&type=template&id=6807e983&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./Modal.scss?vue&type=style&index=0&id=6807e983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807e983",
  null
  
)

export default component.exports